import { useEffect } from 'react'
import { Tabs } from 'components/ideal-core-ui'
import { useImmer } from 'use-immer'
import isEqual from 'lodash/isEqual'
import { QuoteFormats } from './QuoteFormats'
import { Filters } from './Filters'
import { Emails } from './Emails'
import { Fields } from './Fields'
import { EstimateTemplates } from './EstimateTemplates'
import { DocFolders } from './DocFolders'
import { useLocation } from 'react-router'
import qs from 'query-string'
import { refreshSettings } from 'utils/settingsService'
import { useDispatch } from 'react-redux'

const Opportunity = ({ saveDetails, details }) => {
  const [organizationDetails, setOrganizationDetails] = useImmer(details)
  const location = useLocation()
  const search = qs.parse(location.search)
  const dispatch = useDispatch()

  useEffect(() => {
    setOrganizationDetails(() => {
      return details
    })
  }, [details, setOrganizationDetails])

  useEffect(() => {
    if (organizationDetails.id && !isEqual(organizationDetails, details)) {
      saveDetails(organizationDetails, () => refreshSettings(dispatch))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizationDetails])

  return (
    <Tabs
      activeTabKey={search?.secondaryTab || 'fields'}
      withUpdateUrl
      isSecondaryTab
      tabs={[
        {
          key: 'fields',
          label: 'Field Settings',
          value: <Fields details={details} setOrganizationDetails={setOrganizationDetails} />
        },
        {
          key: 'filters',
          label: 'Filters',
          value: <Filters details={details} setOrganizationDetails={setOrganizationDetails} />
        },
        {
          key: 'emails',
          label: 'Auto Emails',
          value: <Emails details={details} setOrganizationDetails={setOrganizationDetails} />
        },
        {
          key: 'quoteProjectNo',
          label: 'Quote # and Project #',
          value: (
            <QuoteFormats
              setOrganizationDetails={setOrganizationDetails}
              details={details}
              saveDetails={saveDetails}
            />
          )
        },
        {
          key: 'estimateTemplates',
          label: 'Estimate Templates',
          value: <EstimateTemplates />
        },
        {
          key: 'docFolders',
          label: 'Doc Folders',
          value: <DocFolders />
        }
      ]}
    />
  )
}

export default Opportunity
